import { render, staticRenderFns } from "./yearCard.vue?vue&type=template&id=2fe3042a&scoped=true&"
import script from "./yearCard.vue?vue&type=script&lang=js&"
export * from "./yearCard.vue?vue&type=script&lang=js&"
import style0 from "./yearCard.vue?vue&type=style&index=0&id=2fe3042a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3042a",
  null
  
)

export default component.exports